import React, { useState, Fragment, Component } from 'react'
import Shimmer from "react-shimmer-effect";
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button,
    Table
} from "reactstrap"
import { Link, useHistory, useParams } from "react-router-dom"
import { withRouter } from "react-router";

import apiResponse from '../../../../services/apiResponse'

import DetailBloc from './Blocs/DetailBloc'
import UpdateBloc from '../CreateJamKerja/Blocs/UpdateBloc'
import moment from 'moment';

class IndexView extends Component {

    detailBloc = new DetailBloc()
    updateBloc = new UpdateBloc()

    constructor(props) {
        super(props)
        this.state = {
            detail: {},
            detailheader: {}
        }
    }

    componentDidMount() {
        this.detailBloc.detailChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if (result.data.status) {
                        let response = result.data.response
                        this.setState({
                            detail: response,
                            working_hours: response.working_hours,
                            presensi_location: response.presensi_location
                        })
                    }
                    break
                case apiResponse.ERROR:

                    break
                default:
                    break
            }
        })
        const queryParams = new URLSearchParams(this.props.location.search)
        this.detailBloc.fetchDetail({ uuid: queryParams.get('uuid'), detail: 1 })
        this.updateBloc.detailChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if (result.data.status) {
                        let response = result.data.response
                        console.log(response)
                        this.setState({
                            detailheader: response
                        })
                    }
                    break
                case apiResponse.ERROR:

                    break
                default:
                    break
            }
        })
        this.updateBloc.fetchDetail({ uuid: queryParams.get('uuid') })
    }

    componentWillUnmount() {
        this.detailBloc.detailChannel?.unsubscribe()
    }

    render() {
        return (
            <Fragment>
                <Container fluid>
                    <Row>
                        <Col className="col-12">

                            <Card>
                                <CardBody>
                                    <CardTitle>Detail Pola Kerja</CardTitle>
                                    {/* <CardSubtitle className="mb-3">
                                        Informasi Detail Pola Kerja
                                    </CardSubtitle> */}
                                    <hr />
                                    <Row className="mb-3">
                                        <label className="col-md-2">
                                            Nama Pola
                                        </label>
                                        <Col md="9">
                                            {
                                                this.state.detailheader ?
                                                    <>{this.state.detailheader.working_pattern_name !== "" ? this.state.detailheader.working_pattern_name : '-'}</>
                                                    : <Shimmer><div style={{ width: '30%', height: 15 }}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>

                                    {/* <Row className="mb-3">
                                        <label className="col-md-2">
                                            Lokasi Absen
                                        </label>
                                        <Col md="9">
                                            {
                                                this.state.detail ?
                                                    <>{this.state.detail.working_pattern_name !== "" ? this.state.detail.working_pattern_name : '-'}</>
                                                : <Shimmer><div style={{width: '30%', height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row> */}

                                    <Row className="mb-3">
                                        <label
                                            htmlFor="working_pattern_name"
                                            className="col-md-2 col-form-label"
                                        >
                                            Jam Kerja
                                        </label>
                                        <Col md="9">
                                            <div className="table-responsive">
                                                <Table className="table-bordered table-striped">
                                                    <thead>
                                                        <tr>
                                                            <th>Hari</th>
                                                            {/* <th>Jenis {this.state.detail?.working_pattern_type == 0}</th> */}
                                                            <th>Jenis {0 == 0}</th>
                                                            {/* <th style={{ width: '110px' }}>{(this.state.detailheader?.working_pattern_type == 0 ? 'Jam Mulai Dapat Absen' : 'Jam Masuk')}</th> */}
                                                            <th style={{ width: '110px' }}>{(0 == 0 ? 'Jam Mulai Dapat Absen' : 'Jam Masuk')}</th>
                                                            {
                                                                // this.state.detailheader?.working_pattern_type == 0 ?
                                                                0 == 0 ?
                                                                    <th style={{ width: '110px' }}>Jam Masuk</th>
                                                                    : ''
                                                            }
                                                            <th style={{ width: '110px' }}>Jam Pulang</th>
                                                            {
                                                                // this.state.detailheader?.working_pattern_type == 0 ?
                                                                0 == 0 ?
                                                                    <th style={{ width: '110px' }}>Jam Akhir Absen</th>
                                                                    : ''
                                                            }
                                                            <th>Mulai Istirahat</th>
                                                            <th>Selesai Istirahat</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {
                                                            this.state.working_hours ?
                                                                this.state.working_hours?.length > 0 ?
                                                                    this.state.working_hours?.map((data, index) => {
                                                                        return (
                                                                            <tr>
                                                                                <td>
                                                                                    {data.working_hours_day_name}
                                                                                </td>
                                                                                <td>
                                                                                    {data.working_hours_type}
                                                                                </td>
                                                                                {
                                                                                    // this.state.detailheader?.working_pattern_type == 0 ?
                                                                                    0 == 0 ?
                                                                                        <td>
                                                                                            {data.working_hours_first_start}
                                                                                        </td>
                                                                                        : ''
                                                                                }
                                                                                <td>
                                                                                    {data.working_hours_start}
                                                                                </td>
                                                                                <td>
                                                                                    {data.working_hours_end}
                                                                                </td>
                                                                                {
                                                                                    // this.state.detailheader?.working_pattern_type == 0 ?
                                                                                    0 == 0 ?
                                                                                        <td>
                                                                                            {data.working_hours_last_end}
                                                                                        </td>
                                                                                        : ''
                                                                                }
                                                                                <td>
                                                                                    {data.working_hours_breaktime_start}
                                                                                </td>
                                                                                <td>
                                                                                    {data.working_hours_breaktime_end}
                                                                                </td>
                                                                            </tr>
                                                                        );
                                                                    })
                                                                    :
                                                                    <tr>
                                                                        <td colSpan="6" className="text-center">
                                                                            Data Jam Kerja Belum Diinput
                                                                        </td>
                                                                    </tr>
                                                                :
                                                                <tr>
                                                                    <td colSpan="6">
                                                                        <Shimmer><div style={{ width: '100%', height: 35 }}></div></Shimmer>
                                                                    </td>
                                                                </tr>
                                                        }

                                                    </tbody>
                                                </Table>
                                            </div>
                                        </Col>
                                    </Row>

                                    {
                                        this.state.presensi_location && (
                                            <>
                                                <Row className="mb-3">
                                                    <label className="col-md-2">
                                                        Lokasi Presensi
                                                    </label>
                                                    <Col md="9">
                                                        {
                                                            this.state.presensi_location ?
                                                                <>{this.state.presensi_location.presensi_location_name !== "" ? this.state.presensi_location.presensi_location_name : '-'}</>
                                                                : <Shimmer><div style={{ width: '30%', height: 15 }}></div></Shimmer>
                                                        }
                                                    </Col>
                                                </Row>


                                                <Row className="mb-3">
                                                    <label
                                                        htmlFor="working_pattern_name"
                                                        className="col-md-2 col-form-label"
                                                    >
                                                        Titik Kordinate
                                                    </label>
                                                    <Col md="9">
                                                        <div className="table-responsive">
                                                            <Table className="table-bordered table-striped">
                                                                <thead>
                                                                    <tr>
                                                                        <th>Latitude </th>
                                                                        <th>Longitude</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {
                                                                        this.state.presensi_location?.presensi_geolocation
                                                                            ? (
                                                                                this.state.presensi_location.presensi_geolocation.length > 0
                                                                                    ? this.state.presensi_location.presensi_geolocation.map((data, index) => (
                                                                                        <tr key={index}>
                                                                                            <td>{data[0]}</td>
                                                                                            <td>{data[1]}</td>
                                                                                        </tr>
                                                                                    ))
                                                                                    : (
                                                                                        <tr>
                                                                                            <td colSpan="2" className="text-center">
                                                                                                Data Titik Koordinat Kosong
                                                                                            </td>
                                                                                        </tr>
                                                                                    )
                                                                            )
                                                                            : (
                                                                                <tr>
                                                                                    <td colSpan="2">
                                                                                        <Shimmer><div style={{ width: '100%', height: 35 }}></div></Shimmer>
                                                                                    </td>
                                                                                </tr>
                                                                            )
                                                                    }
                                                                </tbody>

                                                            </Table>
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </>
                                        )
                                    }



                                    {this.state.detailheader?.working_pattern_type == 0 && (
                                        <Row className="mb-3">
                                            <label className="col-md-2">
                                                Batas Pelaporan WFH
                                            </label>
                                            <Col md="9">
                                                {this.state.detailheader?.working_pattern_wfh_report_limit || '-'} Hari
                                            </Col>
                                        </Row>
                                    )}

                                    <Row className="mb-3">
                                        <Col md="3"></Col>
                                        <Col md="9">
                                            <Link to="?" className="waves-effect">
                                                <Button color="danger"><i className="uil-arrow-left"></i> Kembali</Button>
                                            </Link>
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </Fragment>
        )
    }
}

//export default IndexView
export default withRouter(IndexView);